import { create } from 'zustand';
import _ from 'lodash';

const useSocialRequestStore = create((set, get) => ({
	socialRequestQueue: [],

	addToQueue: (toAdd) => set((state) => {
		let socialRequestQueue;
		if( _.isArray(toAdd) ) {
			socialRequestQueue = _.union(state.socialRequestQueue, toAdd);
		}
		else if( state.socialRequestQueue.indexOf(toAdd) === -1 ) {
			socialRequestQueue = [...state.socialRequestQueue, toAdd];
		}
		else {
			socialRequestQueue = state.socialRequestQueue;
		}
		return { socialRequestQueue };
	}),

	removeFromQueue: (toRemove) => set((state) => {
		let socialRequestQueue;
		if( _.isArray(toRemove) ) {
			socialRequestQueue = state.socialRequestQueue.filter((id) => !toRemove.includes(id));
		}
		else {
			socialRequestQueue = state.socialRequestQueue.filter((id) => toRemove !== id);
		}
		return { socialRequestQueue };
	}),

	clearQueue: () => set({ socialRequestQueue: [] }),

	getQueue: () => get().socialRequestQueue,

	isAssetInQueue: (assetId) => get().socialRequestQueue.indexOf(assetId) > -1
}));

export default useSocialRequestStore;

